<mat-dialog-content class="mat-typography">
  <p>Bitte erstelle zuerst ein Unternehmensprofil</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button  mat-raised-button color="primary"
           [mat-dialog-close]="true"
           routerLink="add-company"
           cdkFocusInitial>OK</button>
</mat-dialog-actions>
